const MS_PER_SECOND = 1_000;
const SECONDS_PER_MINUTE = 60;
const MINUTES_PER_HOUR = 60;

/** The two largest units of a duration, floored to seconds: `45 s`, `1 min 32 s`, `38 min`, `2 h 5 min`. */
export function formatDuration(milliseconds: number): string {
  const totalSeconds = Math.max(0, Math.floor(milliseconds / MS_PER_SECOND));
  const seconds = totalSeconds % SECONDS_PER_MINUTE;
  const totalMinutes = Math.floor(totalSeconds / SECONDS_PER_MINUTE);
  const minutes = totalMinutes % MINUTES_PER_HOUR;
  const hours = Math.floor(totalMinutes / MINUTES_PER_HOUR);

  if (hours > 0) return minutes === 0 ? `${hours} h` : `${hours} h ${minutes} min`;

  if (totalMinutes > 0) return seconds === 0 ? `${minutes} min` : `${minutes} min ${seconds} s`;

  return `${seconds} s`;
}
